import {
  del,
  delBodyJson,
  delJson,
  get,
  getJson,
  patch,
  post,
  postJson,
  put,
  post1
} from './helpers'

// Url used for cross-domain access

const apiUrl = '/api'

// actual api
const login = postJson(`${apiUrl}/login/`)
const loginWithToken = postJson(`${apiUrl}/login_token`)
const logoutWithRefreshToken = postJson(`${apiUrl}/refresh`)
const getJiraUrl = get(`${apiUrl}/login/getJiraUrl`)
const loginWithAccessToken = post(`${apiUrl}/login/loginWithAccessToken`)
const user = getJson(`${apiUrl}/users/`)
const userNames = getJson(`${apiUrl}/user_names`)
const userByID = getJson(`${apiUrl}/user`)
const userUpdate = put(`${apiUrl}/current_user`)
const usersUpdate = put(`${apiUrl}/users/`)
const userConfigUpdate = put(`${apiUrl}/update_query_config`)
const userActive = put(`${apiUrl}/user`)
const userList = get(`${apiUrl}/user/list`)
const userAdd = postJson(`${apiUrl}/add_user`)
const userDel = delJson(`${apiUrl}/user`)
const userGroups = getJson(`${apiUrl}/user_groups`)
const setPassword = patch(`${apiUrl}/user/setpassword`)
const role = getJson(`${apiUrl}/roles/`)
const roleAdd = postJson(`${apiUrl}/add_role_resource`)
const roleUpdate = put(`${apiUrl}/role_resource`)
const roleResource = get(`${apiUrl}/role/resource`)
const getRoleResources = getJson(`${apiUrl}/role_resources/`)
// const getRoleResources = getJson(`${apiUrl}/global_role_permission`)
const roleDelete = delJson(`${apiUrl}/delete_role_resource`)
const resource = getJson(`${apiUrl}/resources`)
const allresources = getJson(`${apiUrl}/all_role_resources`)
const checkedresources = getJson(`${apiUrl}/role_resource_checked_ids`)
const resourceUpdate = put(`${apiUrl}/resource`)
const resourceAdd = postJson(`${apiUrl}/resource`)
const handledTickets = get(`${apiUrl}/ticket/handledTickets`)
const addTicket = post(`${apiUrl}/ticket/add`)
const searchTicket = get(`${apiUrl}/ticket/search`)
const updateTicket = put(`${apiUrl}/ticket/update`)
const issue = get(`${apiUrl}/issue`)
const untouchedIssue = get(`${apiUrl}/issue/untouched`)
const addTicketAssign = post(`${apiUrl}/ticketAssign/add`)
const updateTicketAssign = put(`${apiUrl}/ticketAssign/update`)
const ticketAssign = get(`${apiUrl}/ticketAssign`)
const bugReport = get(`${apiUrl}/bugReport`)
const individualTicketsReport = get(`${apiUrl}/individualTicketsReport`)
const emailNotify = post(`${apiUrl}/ticketAssign/notify`)
const teamGroupList = get(`${apiUrl}/teamGroup`)
const teamGroupAdd = post(`${apiUrl}/teamGroup/add`)
const teamGroupUpdate = put(`${apiUrl}/teamGroup/update`)
const teamGroupDelete = del(`${apiUrl}/teamGroup/delete`)
const dashboards = get(`${apiUrl}/dashboards`)
const generateRport = post(`${apiUrl}/dashboards`)
const updateOthers = put(`${apiUrl}/user`)
const getProjectNum = getJson(`${apiUrl}/project_num/`)
const getProjects = getJson(`${apiUrl}/projects`)
const getProject = getJson(`${apiUrl}/project`)
const getProjectDetail = getJson(`${apiUrl}/project_detail`)
const getFavoriteProjects = getJson(`${apiUrl}/favorite_projects/`)
const getUserProjectAccess = getJson(`${apiUrl}/user_project_accesses`)
const getUserProjectList = getJson(`${apiUrl}/user_project_accesse_infos`)
const updateUserProjectList = put(`${apiUrl}/update_user_project_accesses`)
const updateProject = put(`${apiUrl}/project`)
const addProject = postJson(`${apiUrl}/project`)
const deleteProject = delJson(`${apiUrl}/project`)
const favoriteProject = postJson(`${apiUrl}/favorite_project`)
const unfavoriteProject = delJson(`${apiUrl}/favorite_project`)
const getProjectActivityHistory = getJson(`${apiUrl}/project_activity_history`)
const getProjectActivityTestChanges = getJson(
  `${apiUrl}/project_activity_test_changes`
)
const getRecentMilestones = getJson(`${apiUrl}/project_recent_milestones`)
const getRecentTestruns = getJson(`${apiUrl}/project_recent_runs`)
const getProjectMilestonesList = getJson(`${apiUrl}/project_resource`)
const getMilestone = getJson(`${apiUrl}/milestone`)
const addMilestone = postJson(`${apiUrl}/milestone`)
const deleteMilestone = delJson(`${apiUrl}/milestone`)
const updateMilestone = put(`${apiUrl}/milestone`)
const getParentMilestones = getJson(`${apiUrl}/parentMilestones`)
const getAllMilestoneList = getJson(`${apiUrl}/allMilestoneList`)
const getOpenMilestones = getJson(`${apiUrl}/openMilestones`)
const getCompleteMilestones = getJson(`${apiUrl}/completeMilestones`)
const getUpcomingMilestones = getJson(`${apiUrl}/upcomingMilestones`)
const getSubmilestones = getJson(`${apiUrl}/submilestones`)
const getMilestonesDetail = getJson(`${apiUrl}/milestoneDetail`)
const addTestrun = postJson(`${apiUrl}/run`)
const addTestreRun = postJson(`${apiUrl}/reRun`)
const getTestrun = getJson(`${apiUrl}/run`)
const getTestReRun = getJson(`${apiUrl}/reRun`)
const updateTestrun = put(`${apiUrl}/run`)
const deleteTestrun = delJson(`${apiUrl}/run`)
const getOpenTestruns = getJson(`${apiUrl}/run_open`)
const getUpcomingTestruns = getJson(`${apiUrl}/run_upcoming`)
const getCompletionPendingTestruns = getJson(`${apiUrl}/run_completing`)
const getCompletedTestruns = getJson(`${apiUrl}/run_completed`)
const getAssignTos = getJson(`${apiUrl}/assign_to`)
const getTestsuite = getJson(`${apiUrl}/suite`)
const getTestsuites = getJson(`${apiUrl}/suites`)
const updateTestsuite = put(`${apiUrl}/suite`)
const addTestsuite = postJson(`${apiUrl}/suite`)
const deleteTestsuite = delJson(`${apiUrl}/suite`)
const addSection = postJson(`${apiUrl}/section`)
const editSection = put(`${apiUrl}/section`)
const deleteSection = delJson(`${apiUrl}/section`)
const moveSection = postJson(`${apiUrl}/move_section`)
const copySection = postJson(`${apiUrl}/copy_section`)
const getSectionsCases = getJson(`${apiUrl}/section_cases`)
const getSectionsCasesResults = getJson(`${apiUrl}/section_results`)
const getDeletedSectionCases = getJson(`${apiUrl}/section_all_cases`)
const getSections = getJson(`${apiUrl}/sections`)
const getSelectSection = getJson(`${apiUrl}/selected_section`)
const getSectionParents = getJson(`${apiUrl}/section_parents`)
const getSectionsCasesTree = getJson(`${apiUrl}/section_cases_tree`)
const getSectionCasesData = getJson(`${apiUrl}/section_cases_list`)
const getDeletedSectionCasesTree = getJson(`${apiUrl}/all_cases_tree`)
const getFieldProjects = getJson(`${apiUrl}/field_projects`)
const getCaseFields = getJson(`${apiUrl}/case_fields`)
const addTestCase = postJson(`${apiUrl}/case`)
const getTemplateFields = getJson(`${apiUrl}/template_fields`)
const getTestCase = getJson(`${apiUrl}/case`)
const getTestCaseDetail = getJson(`${apiUrl}/case_detail`)
const getTestCaseHistory = getJson(`${apiUrl}/case_history`)
const getTestCasePagination = getJson(`${apiUrl}/case_pagination`)
const updateTestCase = put(`${apiUrl}/case`)
const updateTestCases = put(`${apiUrl}/cases`)
const getTestCaseManyEditDisplay = postJson(`${apiUrl}/cases_updated_display`)
const getFilterTestCaseManyEditDisplay = postJson(
  `${apiUrl}/filter_cases_updated_display`
)
const getTestCaseTitles = postJson(`${apiUrl}/case_titles`)
const softDeleteSingleTestCase = delBodyJson(`${apiUrl}/soft_delete_case`)
const hardDeleteSingleTestCase = delJson(`${apiUrl}/hard_delete_case`)
const softDeleteBatchTestCase = delBodyJson(`${apiUrl}/soft_delete_cases`)
const hardDeleteBatchTestCase = delBodyJson(`${apiUrl}/hard_delete_cases`)
const getSectionCaseCount = getJson(`${apiUrl}/suite_and_section_case_count`)
const getSectionAndCaseCount = getJson(`${apiUrl}/cases_tree_number`)
const addTestPlan = postJson(`${apiUrl}/plan`)
const editTestPlan = put(`${apiUrl}/plan`)
const getTestPlan = getJson(`${apiUrl}/plan`)
const getProjctPlans = getJson(`${apiUrl}/project_plans`)
const getTestResultStatus = getJson(`${apiUrl}/test_result_status`)
const getRunTestResultStatistics = getJson(`${apiUrl}/test_result_statistics`)
const getTestResults = getJson(`${apiUrl}/test_results`)
const getRerunPlan = getJson(`${apiUrl}/rerun_plan`)
const addRerunPlan = postJson(`${apiUrl}/add_rerun_plan`)
const deleteTestPlan = delJson(`${apiUrl}/plan`)
const getTestResultTree = getJson(`${apiUrl}/test_result_tree`)
const getTestResultPaginationTree = getJson(
  `${apiUrl}/test_result_pagination_tree`
)
const getFilterTestResultPaginationTree = postJson(
  `${apiUrl}/filter_test_result_pagination_tree`
)
const getFilterSectionTestsList = postJson(
  `${apiUrl}/filter_section_tests_list`
)
const getAllSectionCasesTree = getJson(`${apiUrl}/all_section_cases_tree`)
const addCaseTestResult = postJson(`${apiUrl}/add_test_result`)
const addTestResultAndNext = postJson(`${apiUrl}/add_test_result_and_next`)
const addCaseTestResultComment = postJson(`${apiUrl}/add_assign`)
const getTestResultDetail = getJson(`${apiUrl}/get_test_result_detail`)
const bulkAddCaseTestResults = postJson(`${apiUrl}/batch_add_test_result`)
const getRootSectionsCasesTree = getJson(`${apiUrl}/select_root_cases`)
const getSubSectionsCasesTree = getJson(`${apiUrl}/select_cases`)
const getTestResultHistory = getJson(`${apiUrl}/history_context`)
const updateTestResultStatus = put(`${apiUrl}/update_test_result`)
const getTestResultStatusById = getJson(`${apiUrl}/get_test_result_status`)
const getEditRootSectionsCasesTree = getJson(`${apiUrl}/edit_select_root_cases`)
const getEditSubSectionsCasesTree = getJson(`${apiUrl}/edit_select_cases`)
const getRerunRootSectionsCasesTree = getJson(
  `${apiUrl}/rerun_select_root_cases`
)
const getRerunSubSectionsCasesTree = getJson(`${apiUrl}/rerun_select_cases`)
const assignCaseToUser = postJson(`${apiUrl}/add_assign`)
const assignCasesToUser = postJson(`${apiUrl}/batch_add_assign`)
const runSectionsTree = getJson(`${apiUrl}/run_section_tree`)
const getCaseNum = getJson(`${apiUrl}/select_cases_num`)
const getTestPagination = getJson(`${apiUrl}/test_pagination`)
const getMilestoneResult = getJson(`${apiUrl}/milestone_result_statistics`)
const getTestResultPagination = getJson(`${apiUrl}/test_result_pagination_data`)
const updateTestResultAssign = put(`${apiUrl}/update_assign`)
const getTestRunsOnToDos = postJson(`${apiUrl}/todo/get_test_runs`)
const getDashboardOnToDos = postJson(`${apiUrl}/todo/get_dashboard/`)
const getRunsBySuites = getJson(`${apiUrl}/runs`)
const getGroups = getJson(`${apiUrl}/groups`)
const getGroup = getJson(`${apiUrl}/group`)
const getGroupUsers = getJson(`${apiUrl}/group_users`)
const deleteGroup = delJson(`${apiUrl}/group`)
const updateGroup = put(`${apiUrl}/group`)
const addGroup = postJson(`${apiUrl}/group`)
const getSubSections = getJson(`${apiUrl}/sub_sections`)
const getRoleResoucesInfo = getJson(`${apiUrl}/role_resources_info`)
const updateRoleResoucesInfo = postJson(`${apiUrl}/update_role_resource`)
const deleteRole = delJson(`${apiUrl}/role`)
const addRoleResouces = postJson(`${apiUrl}/add_role_and_resources`)
const updateRole = put(`${apiUrl}/role`)
const updateExpandSection = put(`${apiUrl}/expand_section`)
const getProjectAccess = getJson(`${apiUrl}/project_accesses`)
const updateProjectAccess = put(`${apiUrl}/update_project_accesses`)
const moveCase = postJson(`${apiUrl}/move_case`)
const copyCase = postJson(`${apiUrl}/copy_case`)
const updateCaseTitle = put(`${apiUrl}/case_title`)
const getReports = getJson(`${apiUrl}/get_report_list`)
const getPrivateReports = getJson(`${apiUrl}/get_private_report_list`)
const getSharedReports = getJson(`${apiUrl}/get_shared_report_list`)
const deleteReport = delJson(`${apiUrl}/delete_report`)
const addReport = postJson(`${apiUrl}/add_summary_report`)
const getProjectPermissions = getJson(`${apiUrl}/project_role_resources`)
const getFiltercases = postJson(`${apiUrl}/filter_section_cases_list`)
const updateFiltercases = put(`${apiUrl}/filter_cases`)
const getReportsAllMilestones = getJson(`${apiUrl}/reportAllMilestoneList`)
const getProjectRuns = postJson(`${apiUrl}/project_run_list`)
const getTestFirstSectionId = getJson(`${apiUrl}/test_first_section_id`)
const getSectionTestsList = getJson(`${apiUrl}/section_tests_list`)
const addProertyDistributionReport = postJson(
  `${apiUrl}/add_cases_property_distribution_report`
)
const upLoadFile = post1(`${apiUrl}/new_attachment`)
const getProjectAttachment = getJson(`${apiUrl}/case_attachment`)
const addStatusTopsReport = postJson(`${apiUrl}/add_cases_status_tops_report`)
const getReportParas = getJson(`${apiUrl}/get_report_request_params`)
const deleteAttachment = delJson(`${apiUrl}/attachment/`)
const downloadAttachment = postJson(`${apiUrl}/download_attachment/`)
const getRunSubsections = getJson(`${apiUrl}/run_sub_sections`)
const updateRunExpandSection = put(`${apiUrl}/run_expand_section`)
const getRunExpandSections = getJson(`${apiUrl}/run_expand_sections`)
const getDefaultSections = getJson(`${apiUrl}/default_sections`)
const loginWithOkta = getJson(`${apiUrl}/okta_login`)
const getAttachmentInfo = getJson(`${apiUrl}/attachment_info`)
const getProjectPermission = getJson(`${apiUrl}/projects_permission`)
const getbugfields = getJson(`${apiUrl}/jira_bug_fields/`)
const postbugfields = postJson(`${apiUrl}/create_jira_bug/`)
const getJiraUser = getJson(`${apiUrl}/jira_uses/`)
const getRunType = getJson(`${apiUrl}/get_run_type/`)
const getDefectStatistics = getJson(`${apiUrl}/defects_statistics`)
const getDefectMsg = getJson(`${apiUrl}/defects_status`)
const getDefectStaByRunId = getJson(`${apiUrl}/defects_statistics_by_runid`)
const addConfig = postJson(`${apiUrl}/config`)
const deleteConfig = delJson(`${apiUrl}/config`)
const editConfig = put(`${apiUrl}/config`)
const getConfigByProject = getJson(`${apiUrl}/configs`)
const getDefectMsgByRunId = getJson(`${apiUrl}/defects_status_by_runid`)
const getAllProjects = getJson(`${apiUrl}/jira_all_projects_info`)
const getZoomMudule = getJson(`${apiUrl}/jira_zoom_module_info`)
const getPlatForm = getJson(`${apiUrl}/jira_platform_info`)
const getFixVersion = getJson(`${apiUrl}/jira_fix_version`)
const postDefectReport = postJson(`${apiUrl}/add_defects_summary_report`)
const getDefectStaByPlanId = getJson(`${apiUrl}/defects_statistics_by_planid`)
const getDefectMsgPlanId = getJson(`${apiUrl}/defects_status_by_planid`)
const getServiceInfo = getJson(`${apiUrl}/storage_status`)
const getSortCaseTreeList = postJson(`${apiUrl}/sort_filter_case_tree_list`)
const forgetPassword = postJson(`${apiUrl}/forget_password`)
const resetPassword = postJson(`${apiUrl}/reset_password`)
const getPriorityList = getJson(`${apiUrl}/priorities`)
const logOut = postJson(`${apiUrl}/logout`)
const getOnlineUsers = postJson(`${apiUrl}/user_login_list`)
const updateJiraIssue = postJson(`${apiUrl}/update_jira_info`)
const getSectionInRun = postJson(`${apiUrl}/section_in_runlist`)
const getCommonTestRunList = getJson(`${apiUrl}/get_project_all_run`)
const getConfigByToken = getJson(`${apiUrl}/get_config_by_token`)
const filterSelectRootCases = postJson(`${apiUrl}/filter_select_root_cases`)
const filterSelectCases = postJson(`${apiUrl}/filter_select_cases`)
const getAllPorjectSuite = getJson(`${apiUrl}/user_all_suite_accesses`)
const copyFromProjects = postJson(`${apiUrl}/copy_from_project`)
const importCase = postJson(`${apiUrl}/import_cases`)
const copyCases = postJson(`${apiUrl}/copy_cases`)
const updatePlanLock = put(`${apiUrl}/update_plan_lock`)
const updateRunLock = put(`${apiUrl}/update_run_lock`)
const getTasks = getJson(`${apiUrl}/tasks`)
const sectionExists = getJson(`${apiUrl}/section_exists`)
const addCaseForTask = postJson(`${apiUrl}/tasks_case`)
const fillReferences = put(`${apiUrl}/fill_reference`)
const getPushJiraMessage = postJson(`${apiUrl}/get_push_jira`)
const batchUpdateJira = postJson(`${apiUrl}/batch_update_jira_info`)
const casesFieldsType = getJson(`${apiUrl}/cases_fields_type`)
const updateRunTop = put(`${apiUrl}/update_run_top`)
const updatePlanTop = put(`${apiUrl}/update_plan_top`)
const moveCases = postJson(`${apiUrl}/move_cases`)
const getSectionPassedCount = postJson(`${apiUrl}/get_passed_count`)
const updatePassedForTask = postJson(`${apiUrl}/tasks_passed`)
const setSignOff = postJson(`${apiUrl}/sign_off`)
const getSignOffByUser = getJson(`${apiUrl}/sign_off`)
const updateEmailNotify = put(`${apiUrl}/update_email_notify`)
const getLogs = getJson(`${apiUrl}/logs`)
const getBugs = getJson(`${apiUrl}/bug_static`)
const getBugsByUser = getJson(`${apiUrl}/bug`)
const getLogsFiled = getJson(`${apiUrl}/log_field`)
const getMultiGroupUsers = getJson(`${apiUrl}//multi_group_users`)
const getMainPushTojiraMessage = postJson(`${apiUrl}/get_main_push_jira`)
const getIssueSummarys = getJson(`${apiUrl}/get_issue_summarys`)
const getNotification = getJson(`${apiUrl}/notification`)
const getExistsNewNotification = getJson(`${apiUrl}/exists_new_notification`)
const readNotification = postJson(`${apiUrl}/notification`)
const deleteNotification = delJson(`${apiUrl}/notification/`)
const getCaseFieldList = getJson(`${apiUrl}/case_fields`)
const getActiveProjects = getJson(`${apiUrl}/active_projects`)
const getAllSuite = getJson(`${apiUrl}/all_suites`)
const getFieldTypes = getJson(`${apiUrl}/field_types`)
const getTemplates = getJson(`${apiUrl}/templates`)
const getTemplateOptions = getJson(`${apiUrl}/template_options`)
const getProjectNames = getJson(`${apiUrl}/project_names/`)
const getSuite = getJson(`${apiUrl}/suite_info`)
const caseField = postJson(`${apiUrl}/case_field`)
const getAllCaseFields = getJson(`${apiUrl}/all_case_fields`)
const deleteCaseField = delJson(`${apiUrl}/field`)
const addCaseField = postJson(`${apiUrl}/field`)
const getCaseField = getJson(`${apiUrl}/field`)
const updateField = put(`${apiUrl}/field`)
const deleteTemplate = delJson(`${apiUrl}/template`)
const getRolePermissions = getJson(`${apiUrl}/role_permissions`)
const getCaseResultFields = getJson(`${apiUrl}/case_result_fields`)
const addTemplate = postJson(`${apiUrl}/template`)
const getTemplate = getJson(`${apiUrl}/template_info`)
const updateTemplate = put(`${apiUrl}/template`)
const getCaseTree = getJson(`${apiUrl}/case_tree`)
const getStatuses = getJson(`${apiUrl}/statuses/`)
const getStatus = getJson(`${apiUrl}/status`)
const addStatus = postJson(`${apiUrl}/status`)
const deleteStatus = delJson(`${apiUrl}/status`)
const updateStatus = put(`${apiUrl}/status`)
const sortFilter = postJson(`${apiUrl}/sort_filter`)
const caseAssign = postJson(`${apiUrl}/case_assign`)
const expandSection = put(`${apiUrl}/expand_section`)
const getExpandSection = getJson(`${apiUrl}/expand_sections`)
const nextCaseDetail = postJson(`${apiUrl}/next_case_detail`)
const getUpdatedDisplay = getJson(`${apiUrl}/cases_filter_updated_display`)
const updateInstallApplication = put(`${apiUrl}/install_application`)
const getInstallApplication = getJson(`${apiUrl}/install_application`)
const getAllTestFields = getJson(`${apiUrl}/all_test_fields`)
const addTestField = postJson(`${apiUrl}/result_field`)
const exportCases = postJson(`${apiUrl}/export_cases`)
const getMindTree = getJson(`${apiUrl}/mind_tree`)
const caseSectionType = postJson(`${apiUrl}/case_section_type`)
const runSelectSectionTree = postJson(`${apiUrl}/run_select_section_tree`)
const getTestTree = getJson(`${apiUrl}/test_tree`)
const getTestFields = getJson(`${apiUrl}/test_fields`)
const testSortFilter = postJson(`${apiUrl}/test_sort_filter`)
const getTestExpandSections = getJson(`${apiUrl}/test_expand_sections`)
const testExpandSection = put(`${apiUrl}/test_expand_section`)
const getResultFields = getJson(`${apiUrl}/result_fields`)
const getTemplateResultFields = getJson(`${apiUrl}/template_result_fields`)
const runSelectCase = postJson(`${apiUrl}/run_select_case`)
const SelectCasesNum = postJson(`${apiUrl}/select_cases_num`)
const deleteTestField = delJson(`${apiUrl}/result_field`)
const getTestField = getJson(`${apiUrl}/result_field`)
const updateTestField = put(`${apiUrl}/result_field`)
const reRunSectionCase = postJson(`${apiUrl}/rerun_select_section_cases`)
const reRunSelectCases = postJson(`${apiUrl}/rerun_select_cases`)
const getEditRunSpecialTree = getJson(`${apiUrl}/get_edit_run_special_tree`)
const editRun = put(`${apiUrl}/run`)
const getEditRunSectionCases = getJson(`${apiUrl}/edit_run_section_cases`)
const addReRun = postJson(`${apiUrl}/add_reRun`)
const getTestActivity = getJson(`${apiUrl}/test_activity`)
const getTestActivityChart = getJson(`${apiUrl}/test_activity_chart`)
const getStatusTestList = getJson(`${apiUrl}/status_test_list`)
const planConfigGroup = postJson(`${apiUrl}/plan_config_group`)
const planConfig = postJson(`${apiUrl}/plan_config`)
const putPlanConfigGroup = put(`${apiUrl}/plan_config_group`)
const putplanConfig = put(`${apiUrl}/plan_config`)
const getPlanConfig = getJson(`${apiUrl}/plan_config`)
const getPlanConfigGroups = getJson(`${apiUrl}/plan_config_groups`)
const rerunPlan = postJson(`${apiUrl}/rerun_plan`)
const getRunProgressChart = getJson(`${apiUrl}/run_progress_chart`)
const getRunProgressChartList = getJson(`${apiUrl}/run_progress_test_list`)
const getCaseStatusChart = getJson(`${apiUrl}/case_status_chart`)
const getCaseStatuses = getJson(`${apiUrl}/case_statuses`)
const getCaseTests = getJson(`${apiUrl}/case_tests`)
const getProjectTestActivityChart = getJson(`${apiUrl}/project_test_activity_chart`)
const getProjectHistoryList = getJson(`${apiUrl}/project_history_list`)
const getProjectStatusTestChangest = getJson(`${apiUrl}/project_status_test_changes`)
const getTop3Milestones = getJson(`${apiUrl}/top3Milestones`)
const getTop3RunPlans = getJson(`${apiUrl}/top3RunPlans`)
const getOverviewTodoList = getJson(`${apiUrl}/todo/overview_todo_list`)
const deleteMilestones = postJson(`${apiUrl}/delete_milestones`)
const getMilestoneStatusTestList = getJson(`${apiUrl}/milestone_status_test_list`)
const getMilestoneTestActivity = getJson(`${apiUrl}/milestone_test_activity`)
const getMilestoneProgress = getJson(`${apiUrl}/milestone_progress`)
const getMilestoneBugsChart = getJson(`${apiUrl}/milestone_bugs_chart`)
const getMilestoneStatusTestChanges = getJson(`${apiUrl}/milestone_status_test_changes`)
const getPlanStatusTestChanges = getJson(`${apiUrl}/plan_status_test_changes`)
const getRunStatusTestChanges = getJson(`${apiUrl}/run_status_test_changes`)
const getPlanTestActivity = getJson(`${apiUrl}/plan_test_activity`)
const getPlanTestProgress = getJson(`${apiUrl}/plan_progress`)
const getPlanTestBugsChart = getJson(`${apiUrl}/plan_bugs_chart`)
const getPlanTestStatusTestList = getJson(`${apiUrl}/plan_status_test_list`)

const getRunBugsChart = getJson(`${apiUrl}/run_bugs_chart`)
const getPlanBugsChart = getJson(`${apiUrl}/plan_bugs_chart`)
// milstone点击progree图
const getMilestoneProgressTests = getJson(`${apiUrl}/milestone_progress_tests`)
// plan点击progree图
const getPlanProgressTests = getJson(`${apiUrl}/plan_progress_tests`)
// 批量删除plan+run
const deletePlansRuns = postJson(`${apiUrl}/delete_plans_runs`)
// bug
// 获取bug自定义字段
const getAllBugFields = getJson(`${apiUrl}/all_bug_fields`)
// 获取bug项目对应的run
const getBugRuns = getJson(`${apiUrl}/bug_runs`)
// 获取bug项目对应的plan
const getBugPlans = getJson(`${apiUrl}/bug_plans`)

// 获取case的bug
const getCaseBugsChart = getJson(`${apiUrl}/case_bugs_chart`)
// 添加case bug
const addCasebug = postJson(`${apiUrl}/bug`)

// bug的详情
const getBugDetail= getJson(`${apiUrl}/bug_detail`)


export {
  login,
  loginWithToken,
  logoutWithRefreshToken,
  loginWithAccessToken,
  getJiraUrl,
  user,
  userNames,
  userUpdate,
  usersUpdate,
  userConfigUpdate,
  userActive,
  userList,
  userAdd,
  userDel,
  userByID,
  userGroups,
  setPassword,
  role,
  roleAdd,
  roleUpdate,
  roleDelete,
  roleResource,
  resource,
  allresources,
  checkedresources,
  resourceUpdate,
  resourceAdd,
  handledTickets,
  addTicket,
  searchTicket,
  updateTicket,
  issue,
  untouchedIssue,
  ticketAssign,
  addTicketAssign,
  updateTicketAssign,
  bugReport,
  individualTicketsReport,
  emailNotify,
  teamGroupList,
  teamGroupAdd,
  teamGroupUpdate,
  teamGroupDelete,
  dashboards,
  generateRport,
  getRoleResources,
  updateOthers,
  getProjectNum,
  getProjects,
  getProject,
  deleteProject,
  updateProject,
  favoriteProject,
  unfavoriteProject,
  getFavoriteProjects,
  getProjectActivityHistory,
  getProjectActivityTestChanges,
  getRecentMilestones,
  getRecentTestruns,
  addProject,
  getProjectMilestonesList,
  getMilestone,
  addMilestone,
  deleteMilestone,
  updateMilestone,
  getParentMilestones,
  getAllMilestoneList,
  getOpenMilestones,
  getCompleteMilestones,
  getUpcomingMilestones,
  getSubmilestones,
  getTestrun,
  addTestrun,
  addTestreRun,
  deleteTestrun,
  updateTestrun,
  getOpenTestruns,
  getUpcomingTestruns,
  getCompletionPendingTestruns,
  getCompletedTestruns,
  getAssignTos,
  getMilestonesDetail,
  getTestsuite,
  getTestsuites,
  updateTestsuite,
  addTestsuite,
  deleteTestsuite,
  addSection,
  editSection,
  deleteSection,
  moveSection,
  copySection,
  getSections,
  getSectionParents,
  getSectionsCases,
  getSectionsCasesResults,
  getSectionsCasesTree,
  getFieldProjects,
  getCaseFields,
  addTestCase,
  getTestCasePagination,
  getTemplateFields,
  getTestCase,
  getTestCaseDetail,
  getTestCaseHistory,
  updateTestCase,
  updateTestCases,
  getTestCaseManyEditDisplay,
  getFilterTestCaseManyEditDisplay,
  getTestCaseTitles,
  softDeleteSingleTestCase,
  hardDeleteSingleTestCase,
  softDeleteBatchTestCase,
  hardDeleteBatchTestCase,
  getSectionCaseCount,
  addTestPlan,
  addRerunPlan,
  getTestPlan,
  editTestPlan,
  getProjctPlans,
  getTestResultStatus,
  getDeletedSectionCases,
  getDeletedSectionCasesTree,
  deleteTestPlan,
  getRerunPlan,
  getProjectDetail,
  getSectionAndCaseCount,
  getTestResults,
  getTestResultTree,
  getTestResultPaginationTree,
  getFilterTestResultPaginationTree,
  getFilterSectionTestsList,
  getSelectSection,
  getAllSectionCasesTree,
  addCaseTestResult,
  addTestResultAndNext,
  getTestResultDetail,
  getRunTestResultStatistics,
  bulkAddCaseTestResults,
  getRootSectionsCasesTree,
  getSubSectionsCasesTree,
  addCaseTestResultComment,
  getTestResultHistory,
  updateTestResultStatus,
  getTestResultStatusById,
  getEditRootSectionsCasesTree,
  getEditSubSectionsCasesTree,
  getRerunRootSectionsCasesTree,
  getRerunSubSectionsCasesTree,
  assignCaseToUser,
  assignCasesToUser,
  runSectionsTree,
  getCaseNum,
  getTestPagination,
  getMilestoneResult,
  getTestResultPagination,
  updateTestResultAssign,
  getTestRunsOnToDos,
  getDashboardOnToDos,
  getTestReRun,
  getRunsBySuites,
  getSectionCasesData,
  getGroups,
  getGroup,
  getGroupUsers,
  deleteGroup,
  updateGroup,
  addGroup,
  getSubSections,
  getRoleResoucesInfo,
  updateRoleResoucesInfo,
  deleteRole,
  addRoleResouces,
  updateRole,
  updateExpandSection,
  getProjectAccess,
  getUserProjectAccess,
  updateProjectAccess,
  moveCase,
  copyCase,
  getUserProjectList,
  updateUserProjectList,
  updateCaseTitle,
  getReports,
  getPrivateReports,
  getSharedReports,
  deleteReport,
  addReport,
  getProjectPermissions,
  getFiltercases,
  updateFiltercases,
  getReportsAllMilestones,
  getProjectRuns,
  getTestFirstSectionId,
  addProertyDistributionReport,
  getSectionTestsList,
  upLoadFile,
  getProjectAttachment,
  addStatusTopsReport,
  getReportParas,
  deleteAttachment,
  downloadAttachment,
  getRunSubsections,
  updateRunExpandSection,
  getRunExpandSections,
  getDefaultSections,
  loginWithOkta,
  getAttachmentInfo,
  getProjectPermission,
  getbugfields,
  postbugfields,
  getJiraUser,
  getRunType,
  getDefectStatistics,
  getDefectMsg,
  getDefectStaByRunId,
  addConfig,
  deleteConfig,
  editConfig,
  getConfigByProject,
  getDefectMsgByRunId,
  getAllProjects,
  getPlatForm,
  getZoomMudule,
  getFixVersion,
  postDefectReport,
  getDefectStaByPlanId,
  getDefectMsgPlanId,
  getServiceInfo,
  getSortCaseTreeList,
  forgetPassword,
  resetPassword,
  getPriorityList,
  logOut,
  getOnlineUsers,
  updateJiraIssue,
  getSectionInRun,
  getCommonTestRunList,
  getConfigByToken,
  filterSelectRootCases,
  filterSelectCases,
  getAllPorjectSuite,
  copyFromProjects,
  importCase,
  copyCases,
  updatePlanLock,
  updateRunLock,
  getTasks,
  sectionExists,
  addCaseForTask,
  fillReferences,
  getPushJiraMessage,
  batchUpdateJira,
  casesFieldsType,
  updateRunTop,
  updatePlanTop,
  moveCases,
  getSectionPassedCount,
  updatePassedForTask,
  setSignOff,
  getSignOffByUser,
  updateEmailNotify,
  getBugs,
  getBugsByUser,
  getMultiGroupUsers,
  getLogs,
  getLogsFiled,
  getMainPushTojiraMessage,
  getIssueSummarys,
  getNotification,
  getExistsNewNotification,
  readNotification,
  deleteNotification,
  getCaseFieldList,
  getActiveProjects,
  getAllSuite,
  getFieldTypes,
  getTemplates,
  getTemplateOptions,
  getProjectNames,
  getSuite,
  caseField,
  getAllCaseFields,
  deleteCaseField,
  addCaseField,
  getCaseField,
  deleteTemplate,
  getRolePermissions,
  getCaseResultFields,
  addTemplate,
  getTemplate,
  updateTemplate,
  getCaseTree,
  getStatuses,
  getStatus,
  addStatus,
  deleteStatus,
  updateStatus,
  sortFilter,
  caseAssign,
  expandSection,
  getExpandSection,
  nextCaseDetail,
  getUpdatedDisplay,
  updateInstallApplication,
  getInstallApplication,
  getAllTestFields,
  addTestField,
  updateField,
  exportCases,
  getMindTree,
  caseSectionType,
  runSelectSectionTree,
  getTestTree,
  getTestFields,
  testSortFilter,
  getTestExpandSections,
  testExpandSection,
  getResultFields,
  getTemplateResultFields,
  runSelectCase,
  SelectCasesNum,
  deleteTestField,
  getTestField,
  updateTestField,
  reRunSectionCase,
  reRunSelectCases,
  getEditRunSpecialTree,
  editRun,
  getEditRunSectionCases,
  addReRun,
  getTestActivity,
  getTestActivityChart,
  getStatusTestList,
  planConfigGroup,
  planConfig,
  putPlanConfigGroup,
  putplanConfig,
  getPlanConfig,
  getPlanConfigGroups,
  rerunPlan,
  getRunProgressChart,
  getRunProgressChartList,
  getCaseStatusChart,
  getCaseStatuses,
  getCaseTests,
  getProjectTestActivityChart,
  getProjectHistoryList,
  getProjectStatusTestChangest,
  getTop3Milestones,
  getTop3RunPlans,
  getOverviewTodoList,
  deleteMilestones,
  getMilestoneStatusTestList,
  getMilestoneTestActivity,
  getMilestoneProgress,
  getMilestoneBugsChart,
  getMilestoneStatusTestChanges,
  getPlanStatusTestChanges,
  getRunStatusTestChanges,
  getPlanTestActivity,
  getPlanTestProgress,
  getPlanTestBugsChart,
  getPlanTestStatusTestList,
  getAllBugFields,
  getBugRuns,
  getBugPlans,
  getCaseBugsChart,
  addCasebug,
  getRunBugsChart,
  getPlanBugsChart,
  deletePlansRuns,
  getPlanProgressTests,
  getMilestoneProgressTests,
  getBugDetail,
}
